function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import { connect as connectFormik, getIn } from "formik";
import DropdownInput from "../../../../dropdown-input";
var DropdownComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(DropdownComponent, PureComponent);
    var _super = _createSuper(DropdownComponent);
    function DropdownComponent() {
        _classCallCheck(this, DropdownComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleChange = function(selected, _, name) {
            var _props = _this.props, formik = _props.formik, row = _props.row, handleSkipTo = _props.handleSkipTo;
            if (!selected) {
                formik.handleChange({
                    target: {
                        value: "",
                        name: name
                    }
                });
                return;
            }
            handleSkipTo === null || handleSkipTo === void 0 ? void 0 : handleSkipTo(row.order, selected && selected.skipTo);
            formik.handleChange({
                target: {
                    value: Array.isArray(selected) ? selected.map(function(v) {
                        return v.value;
                    }) : selected.value,
                    name: name
                }
            });
        };
        return _this;
    }
    var _proto = DropdownComponent.prototype;
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5;
        var _props = this.props, row = _props.row, formik = _props.formik, hideLabel = _props.hideLabel, disabled = _props.disabled, menuPortalTarget = _props.menuPortalTarget, rest = _objectWithoutProperties(_props, [
            "row",
            "formik",
            "hideLabel",
            "disabled",
            "menuPortalTarget"
        ]);
        var name = row.id;
        var isMulti = (ref = row.options) === null || ref === void 0 ? void 0 : ref.multiple;
        var value = ((ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.items) ? isMulti ? (ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.items.filter(function(op) {
            return (formik.values[row.id] || []).includes(op.value);
        }) : (ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.items.filter(function(op) {
            return op.value === formik.values[row.id];
        }) : "";
        var label = ((ref4 = row.options) === null || ref4 === void 0 ? void 0 : ref4.isRequired) ? "* ".concat(row.label) : row.label;
        var helpText = this.props.allowHelpText ? row.description : "";
        var error = getIn(formik.errors, name);
        var touched = getIn(formik.touched, name);
        return /*#__PURE__*/ React.createElement(DropdownInput, _extends({
            name: name,
            label: label,
            hideLabel: hideLabel,
            helpText: helpText,
            value: value,
            error: touched && error,
            onChange: function(value) {
                _this.handleChange(value, formik, name);
            },
            options: ((ref5 = row.options) === null || ref5 === void 0 ? void 0 : ref5.items) || [],
            isSearchable: isMulti,
            isMulti: isMulti,
            isDisabled: disabled,
            menuPortalTarget: menuPortalTarget ? menuPortalTarget : document.body,
            large: true
        }, rest));
    };
    DropdownComponent.shouldComponentUpdate = function shouldComponentUpdate(nextProps, props) {
        var nextFormik = nextProps.formik, nextDisabled = nextProps.disabled;
        var formik = props.formik, disabled = props.disabled;
        var name = props.row.id;
        return getIn(formik.values, name) !== getIn(nextFormik.values, name) || getIn(formik.errors, name) !== getIn(nextFormik.errors, name) || getIn(formik.touched, name) !== getIn(nextFormik.touched, name) || disabled !== nextDisabled;
    };
    return DropdownComponent;
}(PureComponent);
export default connectFormik(DropdownComponent);
